import { Col, mediaQueries, size } from '@everlywell/leaves';
import { animated } from 'react-spring';
import styled from 'styled-components';

type ColContainerProps = {
  hasOnlyOneImage: boolean;
};
export const ColContainer = styled(Col)<ColContainerProps>`
  .gatsby-image-wrapper img {
    padding: ${size.md}px ${size.lg}px;
  }
  ${mediaQueries.forTabletHorizontalUp} {
    padding: 0;
    .gatsby-image-wrapper img {
      padding: 0;
    }

    margin: ${(props) => (props.hasOnlyOneImage ? 'auto 0' : 'inital')};
  }
`;

export const MobileAnimatedImage = styled(animated.div)`
  max-height: 412px;
  width: auto;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MobileOneImageContainer = styled.div`
  position: relative;
  max-width: 365px;
  margin: 0 auto;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const DesktopOneImageContainer = styled.div`
  position: relative;
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
  }
`;
